export const REVIEW_SECTION_CONTAINER_NAME = 'user-review-section'
export const REVIEW_SECTION_WIDE_BREAKPOINT = 760
